<template>
  <v-navigation-drawer floating class="pt-5">
    <span class="ml-5 font-weight-bold" style="font-size: 1.125rem">
      {{ t('admin.title') }}
    </span>
    <template v-if="!adminDrawerStore.adminDrawerData">
      <v-sheet height="81%">
        <v-skeleton-loader v-for="i in 3" :key="i" type="list-item" class="ma-4 py-3" color="light-gray"/>
      </v-sheet>
    </template>
    <v-item-group v-else v-model="selectedPage" selected-class="bg-grey-lighten-3">
      <v-container>
        <v-row align="center">
          <v-col v-for="(item, index) in adminDrawerStore.adminDrawerData"
                 :key="index"
                 cols="12"
                 md="12">
            <v-item v-slot="{ isSelected, selectedClass, toggle }" :value="item">
              <v-list-item :class="isSelected ? selectedClass : ''"
                           class="rounded-lg px-2 py-4"
                           @click="() => onClick(item, toggle)">
                <template #title>
                  <v-sheet class="d-flex flex-row bg-transparent align-center">
                    <v-chip variant="text" :text="item.label" class="text-subtitle-1 me-auto"/>
                    <AtomsAdminCountByStatus :enabled-count="item.enabledCount"
                                             :disabled-count="item.disabledCount"
                                             :archived-count="item.archivedCount"/>
                  </v-sheet>
                </template>
              </v-list-item>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>

    <template v-slot:append>
      <v-sheet class="pb-6 d-flex flex-column align-start">
        <v-btn color="primary"
               variant="flat"
               prepend-icon="mdi-plus"
               v-if="$route.query.themeId || $route.query.subThemeId || $route.query.questionId"
               class="text-body-1 font-weight-bold w-75 mx-auto"
               @click="createNewElement"
               size="large">
          {{ t('add') }}
        </v-btn>
      </v-sheet>
    </template>
  </v-navigation-drawer>
</template>
<script setup lang="ts">
import {useI18n} from "vue-i18n";
import type {DrawerElement} from "~/types/admin/drawer";
import {useAdminDrawerStore} from "~/stores/admin/drawer";

const {t} = useI18n()
const selectedPage = ref()
const route = useRoute()
const adminDrawerStore = useAdminDrawerStore()

useAsyncData('fetchAdminDrawerData', () => adminDrawerStore.fetchAdminDrawerData())

const {onItemClick} = defineProps<{
  onItemClick: (item: DrawerElement) => void
}>()

// watch([() => route.params, () => adminDrawerData], ([params, drawerData]) => {
//   if (params && drawerData) {
//     const section = params.section as 'themes' | 'subThemes' | 'questions'
//     selectedPage.value = drawerData[section]
//   }
// }, {immediate: true})

const onClick = (item: DrawerElement, toggle: (() => void) | undefined) => {
  if (toggle) toggle()
  onItemClick(item)
}

const createNewElement = async () => {
  await navigateTo(route.path)
  clearNuxtData()
  await refreshNuxtData()
}
</script>
